/// <reference path="../Story/StoryDialog.ts" />

namespace PaperTrail.NewsletterControl {

    @Serenity.Decorators.registerClass()
    export class NewsletterStoriesDialog extends StoryDialog {

        constructor() {
            super();
        }

        updateInterface() {
            super.updateInterface();
            // dany commented out (red line error, no issues encountered though...)
            //this.form.NewslettersList.value = this.form.NewsletterId.value;
            //Serenity.EditorUtils.setReadOnly(this.form.NewsletterId, true); 
        }
    }
}